import script from "./MaritalStatusSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaritalStatusSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
